






























































































































































































import { Component, Vue, Ref, Watch, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import _ from 'lodash'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import EventBus from '@/plugins/EventBus'
import { onlyNumber, timeout } from '@/utils/common'
import { Procedimento } from '@/types/_'

@Component

export default class ComponentModalBackofficeEditarProcedimentosAssociados extends Vue {
  @Prop({ required: false, default: false }) disabled: boolean

  $refs!: { quantidadeForm: any }

  inputSearch: string = ''
  loadEditProcedimentoAssociado: string = ''
  loadRemoveProcedimentoAssociado: string = ''

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get lateralidadeObrigatoria() {
    const { template } = this.getBackofficeGlobalStore
    return !!template.formulario && !!template.formulario.lateralidade && !!template.formulario.lateralidade.exigeLateralidadeEmTodosOsProcedimentos
  }

  get loadingRemoveProcedimentosAssociados() { return this.loadRemoveProcedimentoAssociado }
  set loadingRemoveProcedimentosAssociados(value: string) { this.loadRemoveProcedimentoAssociado = value }

  get loadingEditProcedimentoAssociado() { return this.loadEditProcedimentoAssociado }
  set loadingEditProcedimentoAssociado(value: string) { this.loadEditProcedimentoAssociado = value }

  get showModalEditarProcedimentosAssociados() {
    return this.getBackofficeGlobalStore.modal.editarProcedimentosAssociados
  }

  set showModalEditarProcedimentosAssociados(value: boolean) {
    this.getBackofficeGlobalStore.setModal({ name: 'editarProcedimentosAssociados', value })
  }

  get procedimentosAssociados() {
    return this.getBackofficeGlobalStore.procedimentosAssociados
  }

  get getProcedimentosApi() {
    return this.getBackofficeGlobalStore.procedimentosApi
  }

  get getInputSearch() {
    return this.inputSearch
  }

  set getInputSearch(value) {
    this.inputSearch = value
  }

  async removeProcedimentosAssociado(procedimento: Procedimento) {
    this.loadingRemoveProcedimentosAssociados = procedimento.id
    await this.getBackofficeGlobalStore.removeProcedimentosAssociadoBackoffice(procedimento.id)
    this.getBackofficeGlobalStore.showProcedimentoApi(procedimento)
    this.$forceUpdate()
    this.loadingRemoveProcedimentosAssociados = ''
  }

  addSelected(item) {
    this.procedimento = { quantidade: 1, lateralidade: '', procedimentoPrincipal: false, ...item }
    this.showModalQuantidade = true
  }

  async editSelected(item) {
    await timeout(500)
    this.procedimento = { ...item, procedimentoPrincipal: false, lateralidade: item.lateralidade.key || '' }
    this.showModalQuantidade = true
    this.loadingEditProcedimentoAssociado = ''
  }

  debounce = _.debounce(input => this.getBackofficeGlobalStore.getProcedimentosBackofficeSearch(input), 600)

  search() {
    if (this.inputSearch.length === 0 || this.inputSearch.length > 2) {
      this.debounce(this.inputSearch)
    }
  }

  @Watch('showModalEditarProcedimentosAssociados')
  onChangeShowModalEditarProcedimentosAssociados(value) {
    setTimeout(() => {
      const input = document.querySelector('.procedimentos-associados-backoffice-input input') as HTMLInputElement
      this.getInputSearch = ''
      if (value) {
        input.focus()
      } else {
        input.blur()
        this.getBackofficeGlobalStore.clearProcedimentosApi()
        EventBus.$emit('refreshSolicitacaoAlterada', true)
      }
    }, 100)
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  temFlagDeLateralidadeObrigatoria(value) {
    if (this.lateralidadeObrigatoria && [null, undefined, ''].includes(value)) return false
    return true
  }

  quantidadeRules: any = {
    valid: true,
    quantidade: [v => !!v || 'Campo obrigatório.'],
    lateralidade: [v => this.temFlagDeLateralidadeObrigatoria(v) || 'Campo obrigatório.'],
  }

  procedimento: any = null
  modalQuantidade: boolean = false
  loadSaveProcedimentosAssociados: boolean = false

  get showModalQuantidade() { return this.modalQuantidade }
  set showModalQuantidade(value: boolean) { this.modalQuantidade = value }

  @Watch('showModalQuantidade')
  onChangeShowModalQuantidade(value: boolean) {
    if (!value) this.procedimento = null
  }

  get loadingSaveProcedimentosAssociados() { return this.loadSaveProcedimentosAssociados }
  set loadingSaveProcedimentosAssociados(value: boolean) { this.loadSaveProcedimentosAssociados = value }

  async verificarCoberturaVigente(procedimento: Procedimento) {
    const { hospital } = this.getBackofficeGlobalStore.solicitacaoAlterada
    if (!hospital.hospitalFazConsultaCoberturaVigente || hospital.tipoDeCoberturaVigente !== 'Procedimento') return
    const request = await this.getBackofficeGlobalStore.consultaCoberturaVigente(procedimento.id)
    if (request.success) this.getBackofficeGlobalStore.setProcedimentoAssociadoCoberturaVigente({ ...procedimento, coberturaVigente: request.data.temCoberturaVigente })
  }

  async save() {
    if (!this.$refs.quantidadeForm.validate()) return
    this.loadingSaveProcedimentosAssociados = true
    const procedimentoAssociado: any = { ...this.procedimento }

    Object.entries(procedimentoAssociado).forEach(([key, value]) => {
      if (['', null, 0, undefined].includes(value as any)) delete procedimentoAssociado[key]
    })

    const lateralidade = !procedimentoAssociado.lateralidade ? 'NaoAplica' : procedimentoAssociado.lateralidade

    const { procedimentosAssociados } = this.getBackofficeGlobalStore.solicitacaoAlterada
    const procedimentoAssociadoNew = {
      codigo: procedimentoAssociado.codigo,
      descricao: procedimentoAssociado.descricao,
      id: procedimentoAssociado.id,
      lateralidade: {
        display: lateralidade === 'NaoAplica' ? 'Não Aplica' : lateralidade,
        key: lateralidade,
      },
      procedimentoPrincipal: false,
      quantidade: procedimentoAssociado.quantidade,
    } as any as Procedimento

    if (procedimentosAssociados.some((procedimento: any) => procedimento.id === procedimentoAssociadoNew.id)) {
      this.getBackofficeGlobalStore.setProcedimentoAssociadosSolicitacaoAlterada(procedimentoAssociadoNew)
    } else {
      procedimentosAssociados.push(procedimentoAssociadoNew)
    }

    await this.verificarCoberturaVigente(procedimentoAssociadoNew)

    this.getBackofficeGlobalStore.setSolicitacaoAlteradaFields({ field: 'procedimentosAssociados', value: procedimentosAssociados })
    this.getBackofficeGlobalStore.hideProcedimentoApi(procedimentoAssociadoNew)
    this.loadingSaveProcedimentosAssociados = false
    this.showModalQuantidade = false
  }
}
